export class PerformanceDateMisalignedError extends Error {
	constructor(public portfolioIds: string[], public securitiesByPortfolio?: { [key: string]: any }) {
		super();
		Object.setPrototypeOf(this, PerformanceDateMisalignedError.prototype);
	}
}
